<template>
  <div>
    <div class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <h4 class="card-title">Properties</h4>
        <span class="badge badge-success" style="float: right"
          >Total: {{ properties.total }}</span
        >
      </div>
      <div class="card-content">
        <div class="card-body pb-1">
          <div class="row align-items-center">
            <div class="col">
              <div
                id="properties-chart"
                class="d-flex justify-content-center"
              ></div>
            </div>
            <div class="col">
              <ul class="list-group list-group-flush">
                <li
                  class="list-group-item border-0 d-flex align-items-center justify-content-between px-0"
                >
                  <strong>Average Prices: </strong>
                  <span v-if="properties.averagePrices.jod">{{ properties.averagePrices.jod.toFixed(2) }}JOD /</span>
                  <span v-if="properties.averagePrices.lbp">{{ properties.averagePrices.lbp.toFixed(2) }}LBP</span>
                </li>
                <li
                  class="list-group-item border-0 d-flex align-items-center justify-content-between px-0"
                >
                  <strong>Average Prices (SQM): </strong>
                  <span v-if="properties.averagePricesPerSqm.jod">{{ properties.averagePricesPerSqm.jod.toFixed(2) }}JOD /</span>
                  <span v-if="properties.averagePricesPerSqm.lbp">{{ properties.averagePricesPerSqm.lbp.toFixed(2) }}LBP</span>
                </li>
                <li
                  class="list-group-item border-0 d-flex align-items-center justify-content-between px-0"
                >
                  <strong>Average Size: </strong>
                  {{ (properties.averageSize) ? properties.averageSize.toFixed(2) : 0 }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <h4 class="card-title">Property Locations</h4>

          <div class="accordion" id="accordionWrapa2">
            <PropertyPerCityCard
              v-for="(city, index) in properties.typesPerCity"
              :key="index"
              :city="index"
              :data="city"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PropertyPerCityCard from "@/components/Dashboard/PropertyPerCityCard";
import ApexCharts from 'apexcharts'

export default {
  props: ["properties"],
  components: {
    PropertyPerCityCard,
  },
  methods: {
    initPropertiesChart() {
      const donutChartOption = {
        chart: {
          width: 200,
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        series: [],
        labels: [],
        stroke: {
          width: 0,
          lineCap: "round",
        },
        colors: ["#00CFDD", "#FDAC41", "#5A8DEE", "#39DA8A"],
        plotOptions: {
          pie: {
            donut: {
              size: "90%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "15px",
                  colors: "#596778",
                  offsetY: 20,
                  fontFamily: "IBM Plex Sans",
                },
                value: {
                  show: true,
                  fontSize: "26px",
                  fontFamily: "Rubik",
                  color: "#475f7b",
                  offsetY: -20,
                  formatter: function (val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#828D99",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce(function (a, b) {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        legend: {
          show: false,
        },
      };
      const donutChart = new ApexCharts(
        document.querySelector("#properties-chart"),
        donutChartOption
      );

      this.properties.types.counts.forEach((type) => {
        for (const [key, value] of Object.entries(type)) {
          donutChartOption.labels.push(key);
          donutChartOption.series.push(value);
        }
      });

      donutChart.render();
    },
  },
  mounted() {
    this.initPropertiesChart();
  },
};
</script>

